export enum ShiftDurationCategory {
  Day7 = 7,
  Day30 = 30,
  Day90 = 90,
  Day180 = 180,
  Day365 = 365,
  Day730 = 730,
  Day1095 = 1095,
}

export const ShiftDurationCategories = [
  ShiftDurationCategory.Day7,
  ShiftDurationCategory.Day30,
  ShiftDurationCategory.Day90,
  ShiftDurationCategory.Day180,
  ShiftDurationCategory.Day365,
  ShiftDurationCategory.Day730,
  ShiftDurationCategory.Day1095,
];

export function getShiftDurationCategory(shiftDurationCategory: ShiftDurationCategory) {
  switch (shiftDurationCategory) {
    case ShiftDurationCategory.Day7:
      return "7天";
    case ShiftDurationCategory.Day30:
      return "1个月";
    case ShiftDurationCategory.Day90:
      return "3个月";
    case ShiftDurationCategory.Day180:
      return "半年";
    case ShiftDurationCategory.Day365:
      return "1年";
    case ShiftDurationCategory.Day730:
      return "2年";
    case ShiftDurationCategory.Day1095:
      return "3年";
  }
}